import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { productCenterContent } from '@/mocks/products';
import { serverDetailData } from '@/mocks/serverDetail';

const PLATFORM_URL = '#';

export default function ProductServerDetail() {
  const product = productCenterContent.items.find(
    (item) => item.slug === 'cloudusb-server',
  );
  const otherProducts = productCenterContent.items.filter(
    (item) => item.slug !== 'cloudusb-server',
  );

  if (!product) return null;

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        {/* Header */}
        <section className="pt-28 md:pt-36 pb-10 md:pb-14 bg-background-50">
          <div className="w-full px-4 md:px-8 lg:px-12 xl:px-20 max-w-[1400px] mx-auto">
            <nav className="mb-8 flex items-center gap-2 text-sm text-foreground-300">
              <Link to="/" className="hover:text-primary-400 transition-colors">
                首页
              </Link>
              <i className="ri-arrow-right-s-line" />
              <Link
                to="/product-center"
                className="hover:text-primary-400 transition-colors"
              >
                产品中心
              </Link>
              <i className="ri-arrow-right-s-line" />
              <span className="text-foreground-100 font-medium">
                {product.titleCn}
              </span>
            </nav>

            <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
              <div className="max-w-3xl">
                <div className="flex items-center gap-3 mb-5">
                  <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-500 text-foreground-50">
                    <i className={`${product.icon} text-2xl`} />
                  </div>
                  <span className="text-sm font-medium text-primary-400 tracking-wide font-label">
                    {product.titleEn}
                  </span>
                </div>
                <h1 className="text-3xl md:text-5xl font-black text-foreground-50 font-heading">
                  {product.titleCn}
                </h1>
                <p className="mt-5 text-base md:text-lg text-foreground-300 leading-relaxed max-w-2xl">
                  {product.desc}
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* 产品介绍 */}
        <section className="pb-16 md:pb-24 bg-background-50">
          <div className="w-full px-4 md:px-8 lg:px-12 xl:px-20 max-w-[1400px] mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <h2 className="text-xl md:text-2xl font-bold text-foreground-50 font-heading">
                    产品介绍
                  </h2>
                  <div className="flex-1 h-px bg-background-200/60" />
                </div>
                <p className="text-sm md:text-base text-foreground-300 leading-loose">
                  {product.intro}
                </p>
              </div>
              <div className="relative rounded-lg overflow-hidden border border-background-200/50 bg-background-100">
                <img
                  src={product.image}
                  alt={product.titleCn}
                  title={`${product.titleCn} ${product.titleEn}`}
                  className="w-full h-64 md:h-80 object-contain object-center"
                />
              </div>
            </div>
          </div>
        </section>

        {/* 产品型号矩阵 */}
        <section className="bg-background-100 py-16 md:py-24">
          <div className="w-full px-4 md:px-8 lg:px-12 xl:px-20 max-w-[1400px] mx-auto">
            <div className="text-center mb-12 md:mb-16">
              <h2 className="text-xl md:text-2xl font-bold text-foreground-50 font-heading">
                产品型号
              </h2>
              <p className="mt-3 text-sm text-foreground-300">
                机柜型与桌面型多规格覆盖，适配不同部署场景
              </p>
              <div className="mt-4 mx-auto w-12 h-0.5 bg-primary-500 rounded-full" />
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {serverDetailData.models.map((model, idx) => (
                <Link
                  key={model.name}
                  to={
                    idx === 0
                      ? '/product-center/cloudusb-server/cloudusb-k45'
                      : idx === 1
                        ? '/product-center/cloudusb-server/cloudusb-k24'
                        : idx === 2
                          ? '/product-center/cloudusb-server/cloudusb-mk45'
                          : idx === 3
                            ? '/product-center/cloudusb-server/cloudusb-mk24'
                            : idx === 4
                              ? '/product-center/cloudusb-server/cloudusb-p40'
                              : idx === 5
                                ? '/product-center/cloudusb-server/cloudusb-yz40'
                                : idx === 6
                                  ? '/product-center/cloudusb-server/cloudusb-cx'
                                  : '#'
                  }
                  className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/50 hover:border-primary-500/40 transition-all duration-300 flex flex-col"
                >
                  <div className="relative w-full aspect-[3/2] bg-background-100 overflow-hidden">
                    <img
                      src={model.image}
                      alt={model.name}
                      title={`${model.name} 网银U盾服务器`}
                      className="w-full h-full object-contain object-center group-hover:scale-105 transition-transform duration-700"
                    />
                  </div>
                  <div className="p-5 flex flex-col flex-1">
                    <span className="text-xs font-medium text-primary-400">
                      {model.subtitle}
                    </span>
                    <h3 className="mt-1 text-base font-bold text-foreground-50">
                      {model.name}
                    </h3>
                    <div className="mt-3 space-y-1.5">
                      {model.features.map((f) => (
                        <div
                          key={f}
                          className="flex items-center gap-2 text-xs text-foreground-300"
                        >
                          <i className="ri-check-line text-primary-500" />
                          {f}
                        </div>
                      ))}
                    </div>
                    {model.intro && (
                      <p className="mt-3 pt-3 border-t border-background-200/60 text-xs text-foreground-300 leading-relaxed line-clamp-2">
                        {model.intro}
                      </p>
                    )}
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* 资质认证 */}
        <section className="py-16 md:py-24 bg-background-50">
          <div className="w-full px-4 md:px-8 lg:px-12 xl:px-20 max-w-[1400px] mx-auto">
            <div className="text-center mb-12 md:mb-16">
              <h2 className="text-xl md:text-2xl font-bold text-foreground-50 font-heading">
                资质认证
              </h2>
              <p className="mt-3 text-sm text-foreground-300">
                行业领先的认证与测评资质，保障设备安全合规
              </p>
              <div className="mt-4 mx-auto w-12 h-0.5 bg-primary-500 rounded-full" />
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
              {serverDetailData.certifications.map((cert) => (
                <div
                  key={cert.name}
                  className="flex flex-col items-center text-center p-6 md:p-8 rounded-lg bg-background-100 border border-background-200/50"
                >
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-500/10 text-primary-500 mb-4">
                    <i className={`${cert.icon} text-2xl`} />
                  </div>
                  <h3 className="text-base font-bold text-foreground-50">
                    {cert.name}
                  </h3>
                  <p className="mt-2 text-xs text-foreground-300 leading-relaxed">
                    {cert.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* 核心能力 - 从mock数据 */}
        <section className="bg-background-100 py-16 md:py-24">
          <div className="w-full px-4 md:px-8 lg:px-12 xl:px-20 max-w-[1400px] mx-auto">
            <div className="flex items-end justify-between">
              <div>
                <h2 className="text-xl md:text-2xl font-bold text-foreground-50 font-heading">
                  核心能力
                </h2>
                <div className="mt-4 w-12 h-0.5 bg-primary-500 rounded-full" />
              </div>
              <span className="hidden sm:block text-sm text-foreground-300 font-label">
                共 {product.features.length} 项
              </span>
            </div>

            <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-6 md:gap-8">
              {product.features.map((feature, idx) => (
                <div
                  key={feature.title}
                  className="group relative bg-background-50 rounded-lg border border-background-200/50 p-8 md:p-10 overflow-hidden transition-all duration-300 hover:border-primary-500/40"
                >
                  <span className="absolute top-6 right-6 text-5xl md:text-6xl font-black text-background-200 group-hover:text-primary-400/20 transition-colors font-heading leading-none">
                    {String(idx + 1).padStart(2, '0')}
                  </span>
                  <div className="relative">
                    <div className="w-14 h-14 flex items-center justify-center rounded-lg bg-background-100 text-primary-500 mb-6 group-hover:bg-primary-500 group-hover:text-foreground-50 transition-colors">
                      <i className={`${feature.icon} text-2xl`} />
                    </div>
                    <h3 className="text-lg md:text-xl font-bold text-foreground-50">
                      {feature.title}
                    </h3>
                    <p className="mt-3 text-sm text-foreground-300 leading-relaxed">
                      {feature.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* 应用场景 */}
        <section className="py-16 md:py-24 bg-background-50">
          <div className="w-full px-4 md:px-8 lg:px-12 xl:px-20 max-w-[1400px] mx-auto">
            <div className="text-center mb-12 md:mb-16">
              <h2 className="text-xl md:text-2xl font-bold text-foreground-50 font-heading">
                适用场景
              </h2>
              <p className="mt-3 text-sm text-foreground-300">
                广泛应用于央国企与大型企业的财务与业务管理场景
              </p>
              <div className="mt-4 mx-auto w-12 h-0.5 bg-primary-500 rounded-full" />
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
              {serverDetailData.scenarios.map((s) => (
                <div
                  key={s.name}
                  className="flex flex-col items-center text-center p-6 rounded-lg bg-background-100 border border-background-200/50"
                >
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-500/10 text-primary-500 mb-4">
                    <i className={`${s.icon} text-2xl`} />
                  </div>
                  <h3 className="text-base font-bold text-foreground-50">
                    {s.name}
                  </h3>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="bg-primary-500 py-16 md:py-24">
          <div className="w-full px-4 md:px-8 lg:px-12 xl:px-20 max-w-[1400px] mx-auto text-center">
            <div className="w-14 h-14 flex items-center justify-center rounded-full bg-foreground-50/10 text-foreground-50 mx-auto mb-6">
              <i className="ri-chat-3-line text-2xl" />
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-50 font-heading mb-4">
              了解更多 CloudUSB 系列产品
            </h2>
            <p className="text-base text-foreground-100/80 max-w-2xl mx-auto mb-10 leading-relaxed">
              我们的专业团队可根据您的部署规模与场景需求，提供定制化的U盾服务器选型建议。
            </p>
            <a
              href={PLATFORM_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-8 py-4 bg-foreground-50 text-primary-500 text-base font-semibold rounded-lg hover:bg-background-50 transition-colors whitespace-nowrap"
            >
              立即咨询
              <i className="ri-arrow-right-line" />
            </a>
          </div>
        </section>

        {/* Other products */}
        <section className="py-16 md:py-24 bg-background-100">
          <div className="w-full px-4 md:px-8 lg:px-12 xl:px-20 max-w-[1400px] mx-auto">
            <div className="flex items-end justify-between">
              <div>
                <h2 className="text-xl md:text-2xl font-bold text-foreground-50 font-heading">
                  其它产品
                </h2>
                <div className="mt-4 w-12 h-0.5 bg-primary-500 rounded-full" />
              </div>
              <Link
                to="/product-center"
                className="inline-flex items-center gap-2 text-sm font-medium text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap"
              >
                查看全部
                <i className="ri-arrow-right-line" />
              </Link>
            </div>

            <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {otherProducts.map((item) => (
                <Link
                  key={item.slug}
                  to={`/product-center/${item.slug}`}
                  className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/50 hover:border-primary-500/40 transition-all duration-300"
                >
                  <div className="relative w-full aspect-[3/2] bg-background-100 overflow-hidden">
                    <img
                      src={item.image}
                      alt={item.titleCn}
                      title={`${item.titleCn} ${item.titleEn}`}
                      className="w-full h-full object-contain object-center group-hover:scale-105 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
                    <div className="absolute bottom-3 left-4 w-10 h-10 flex items-center justify-center rounded-lg bg-background-50/90 text-primary-500">
                      <i className={`${item.icon} text-lg`} />
                    </div>
                  </div>
                  <div className="p-6">
                    <h3 className="text-base md:text-lg font-bold text-foreground-50 group-hover:text-primary-400 transition-colors">
                      {item.titleCn}
                    </h3>
                    <p className="mt-2 text-sm text-foreground-300 leading-relaxed line-clamp-2">
                      {item.desc}
                    </p>
                    <div className="mt-4 inline-flex items-center gap-2 text-sm font-medium text-foreground-400 group-hover:text-primary-400 transition-colors">
                      <span>查看详情</span>
                      <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}